import myNetwork from '@/mycore/network/apimanagement';
import * as api from '../../../mycore/module/api';
/**
 * API lay thong tin homepage
 *
 * @param {*} myData
 * @param {*} callback
 */
export function getHomeBanner(callback) {
    myNetwork
        .post('/api/cms/side-banner')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getFeaturedNews(callback) {
    myNetwork
        .post('/api/cms/news', {
            service_code: 'home',
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getLatestOffers(callback, locationid, districtname) {
    myNetwork
        .post('/api/cms/interested-promo', {
            DisplayType: '1',
            locationid: locationid,
            District: districtname,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getMostInterested(callback, locationid, districtname) {
    myNetwork
        .post('/api/cms/interested-promo', {
            DisplayType: '2',
            locationid: locationid,
            District: districtname,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getDropdownWarranty(callback) {
    myNetwork
        .post('/api/cms/warranty/service')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getWarranty(callback, ordercode) {
    myNetwork
        .post('/api/cms/warranty', {
            service_code: ordercode,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function checkToken(callback, token) {
    myNetwork
        .post('/api/saleplatform/authencation/check-token', {
            PublicToken: token,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function getSetting(callback, saleteamid, orderid, billtype) {
    myNetwork
        .post('/api/saleplatform/configuration/get-saleteam-setting', {
            SaleTeamId : saleteamid,
            OrderID: orderid,
            BillType: billtype,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function getAddress(callback, lat, long) {
    myNetwork
        .post('/api/cms/address', {
            lat: lat,
            long: long,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

// export function updateCampinfo(callback, campinfo) {
//     myNetwork
//         .post('/api/orders/update-campinfo', {
//             utm_source: campinfo.utm_source,
//             utm_medium: campinfo.utm_medium,
//             utm_name: campinfo.utm_campaign,
//             utm_term: campinfo.utm_term,
//             utm_content: campinfo.utm_content
//         })
//         .then((response) => {
//             callback(true, response.data, null);
//         })
//         .catch((error) => {
//             callback(false, null, { message: error });
//         });
// }

// export function getLocationByLntLng(callback, lat, long) {
//     myNetwork
//         .post('/api/orders/get-location-by-lnt-lng', {
//             lat: lat,
//             long: long
//         })
//         .then((response) => {
//             callback(true, response.data, null);
//         })
//         .catch((error) => {
//             callback(false, null, { message: error });
//         });
// }

// export function tracking(callback, ordercode) {

//     myNetwork.post('/api/orders/tracking', { 'ordercode': ordercode })
//         .then(response => {
//             callback(true, response.data, null);
//         })
//         .catch(error => {
//             callback(false, null, { message: error });
//         });
// }

export function SearchOrder(callback, ordercode) {

    myNetwork.post('/api/saleplatform/order/search-order', { 'OrderCode': ordercode })
        .then(response => {
            callback(true, response.data, null);

        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getCategories(callback, locationid, districtid, wardid) {
    myNetwork.post('/api/saleplatform/catalog/get-categories', {
            'SaleTeamId': parseInt(sessionStorage.SaleTeamId) || 29,
            'CusTypeId': 102,
            'CusTypeL2Id': 132,
            'LocationId': locationid || 8,
            'DistrictId': districtid || 1,
            'WardId': wardid || 1,
            'PageType': 1
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        })
}
export function getCateFgame(callback, locationid, districtid, wardid) {
    myNetwork.post('/api/saleplatform/catalog/get-home-service', {
            'SaleTeamId': parseInt(sessionStorage.SaleTeamId) || 29,
            'CusTypeId': 102,
            'CusTypeL2Id': 132,
            'LocationId': locationid || 8,
            'DistrictId': districtid || 1,
            'WardId': wardid || 1,
            'PageType': 1
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        })
}
export function getPaymentMethod(callback, orderid) {
    api.getPaymentMethod(callback, orderid)
}

export function trackingOrder(callback, ordercode) {

    myNetwork.post('/api/saleplatform/order/tracking-order', { 'OrderCode': ordercode })
        .then(response => {
            callback(true, response.data, null);

        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function searchOrderCaptcha(callback, ordercode, captcha) {
    myNetwork
        .post('/api/saleplatform/order/search-order-captcha', { OrderCode: ordercode, googleRecaptchaResponse : captcha })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function checkCaptchaSearchOrder(callback, ordercode) {
    myNetwork
        .post('/api/saleplatform/order/check-captcha-search-order', { OrderCode: ordercode })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function listPosts(callback) {
    myNetwork
        .post('/api/cms/posts')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getPopupConfig(callback, pageCode){
    myNetwork.post('/api/cms/popup-megasale', { page_code: pageCode }).
    then((response) => {
        callback(true, response.data, null);
    }).catch((error) => {
        callback(false, null, { message: error });
    })
}

export function getListHomeBanner(callback) {
    myNetwork
        .post('/api/cms/home-banner')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
// Config
export function getConfig(callback) {
    myNetwork
        .post('/api/cms/config')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
export function getLocation(callback) {

    myNetwork.post('/api/saleplatform/geography/get-location')
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
export function RegisterAccount(callback, payload) {
    myNetwork.post('/api/saleplatform/order/fsafe-go/register-account', payload)
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}

